(() => {
	angular.module('main').directive('modalSendMail', modalSendMail);

	modalSendMail.$inject = [
		'$http',
		'$rootScope',
		'$q',
		'$route',
		'$location',
		'messageService',
		'jobDataService',
		'fileUploadService',
		'validationService',
		'templateRequestsService',
		'emailService',
		'workflowDataService',
		'jobTypesDataService',
		'newJobsDataService',
		'workflowService',
		'utilsService',
		'stringModifierService'
	];

	function modalSendMail(
		$http,
		$rootScope,
		$q,
		$route,
		$location,
		messageService,
		jobDataService,
		fileUploadService,
		validationService,
		templateRequestsService,
		emailService,
		workflowDataService,
		jobTypesDataService,
		newJobsDataService,
		workflowService,
		utilsService,
		stringModifierService
	) {
		return {
			restrict: 'E',
			scope: {
				mailData: '<snMailData',
				isClientsOverview: '=snHideLink',
				customToken: '=snCustomToken',
				mailDataClient: '<',
				onCcResubscribe: '&',
				updateParent: '&?',
				mainShootLabelName: '=',
				extraShootLabelName: '=',
				businessNumberLabelName: '='
			},
			template() {
				const templateHtml = `
                <div id="main-wrapper" class="container">
                    <div id="sendContactEmailModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <form class="modal-content form-horizontal" role="form" 
                                  ng-submit="mailDataClient.status===undefined ? sendUserEmail() : sendUserEmailReply()">
                                <div class="modal-header">
                                    <button ng-click="modalClose()" btn-close ></button>
                                    <h3 class="modal-title">Send Email</h3> </div>
                                <div class="modal-body">
                                    <p ng-show="isClientsOverview && !isClientProfile" class="send-mail-description">Note: if you would like to send your client a quote, invoice, contract or questionnaire please 
                                        <a class="add-job-link color-java" href="javascript:void(0);" ng-click="addNewJob($event)">add a new job</a>
                                       for this client first. All quotes, invoices, contracts and questionnaires are managed from within the job profile page.</p>
                                    <div class="field-info">
                                       <h4 class="mt-0">To</h4>
                                        <div class="flex-row">
                                            <input
                                            	 id="sendMessageData_emailTo"
                                                 class="form-control" 
                                                 ng-if="mailDataClient.status === undefined"
                                              	 autocomplete="off"
                                                 type="email"
                                                 placeholder="myclient@abc.com" 
                                                 typeahead="clientemail as clientemail.name for clientemail in clientEmails | filter:$viewValue" 
                                                 typeahead-on-select="setEmail($item, 'sendMessageData', 'emailTo')" 
                                                 ng-change="changeInputField('sendMessageData','emailTo')"
                                                 ng-model="sendMessageData.emailTo"
                                                 ng-disabled="mailData.isDisable"
                                                 required
                                                 maxlength="255">
                                            <input 
                                              class="form-control"
                                              ng-if="mailDataClient.status === null" 
                                              typeahead="clientemail as clientemail.name for clientemail in clientEmails | filter:$viewValue" 
                                              autocomplete="off" 
                                              type="email" 
                                              placeholder="myclient@abc.com" 
                                              ng-model="mailDataClient.from"
                                              typeahead-on-select="setEmail($item, 'mailDataClient','from')" 
                                              ng-change="changeInputField('mailDataClient','from')"
                                              required
                                              maxlength="255"
                                              id="mailDataClient_from"
                                              >
                                            <button type="button" class="btn btn-link color-java" ng-show="!showCcField && !mailData.isDisable" ng-click="toggleViewCc()">Add Cc </button>
                                        </div>
                                    </div>
                                    <div class="field-info" ng-show="showCcField && mailDataClient.status===undefined">
                                        <h4>Cc</h4>
                                        <input id='sendMessageData_emailCc' 
                                               autocomplete="off" 
                                               class="form-control" 
                                               type="email" 
                                               placeholder="another@email.com" 
                                               typeahead="clientemail as clientemail.name for clientemail in clientEmails | filter:$viewValue" 
                                               typeahead-on-select="setEmail($item, 'sendMessageData','emailCc')" 
                                               ng-change="changeInputField('sendMessageData','emailCc')"
                                           	   ng-model="sendMessageData.emailCc" 
                                               maxlength="255">
                                    </div>
                                  
                                    <div class="field-info" ng-show="showCcField && mailDataClient.status===null">
                                        <h4>Cc</h4>
                                        <input id='mailDataClient_emailCc' 
                                               autocomplete="off" 
                                               class="form-control" 
                                               type="email" 
                                               placeholder="another@email.com" 
                                               typeahead="clientemail as clientemail.name for clientemail in clientEmails | filter:$viewValue" 
                                               typeahead-on-select="setEmail($item, 'mailDataClient','emailCc')" 
                                               ng-change="changeInputField('mailDataClient','emailCc')"
                                         	   ng-model="mailDataClient.emailCc" 
                                               maxlength="255">
                                    </div>
                                    <div class="field-info">
  
                                        <h4>Email template</h4>
                                        <div class="flex-row" ng-if="mailDataClient.status === undefined">
                                            <div class="select-style flex-grow-1">
                                                <select
                                                 	ng-model="$parent.selectedEmailTemplate" 
                                                 	ng-change="changEmail(selectedEmailTemplate)"
                                                  	ng-disabled = "!emailTemplates.length || button_disable"
                                               		ng-options="template as template.name for template in emailTemplates | orderBy track by template.name">   
                                                    <option value="">Choose an existing email template</option>
                                                </select>
                                            </div>
                                        </div>   
                                                                                   
                                        <div class="flex-row" ng-if="mailDataClient.status === null">
                                            <div class="select-style flex-grow-1">
                                                <select ng-model="mailDataClient.choosenEmail" ng-change="changEmailClient()" ng-disabled="button_disable" ng-options="item as item.name for item in mailDataClient.emails | orderBy">
                                                    <option value="">Choose an existing email template</option>
                                                </select>
                                            </div>   
                                        </div>
                                    </div>
                                  
                                    <sn-input-text sn-title="Subject" sn-model="sendMessageData.emailSubject" sn-placeholder="Write an awesome subject line. Why not?" ng-if="mailDataClient.status===undefined"></sn-input-text>
                                    <sn-input-text sn-title="Subject" sn-model="mailDataClient.emailSubject" sn-placeholder="Write an awesome subject line. Why not?" ng-if="mailDataClient.status === null"></sn-input-text>
                                    <div class="field-info" ng-class="{'clients-overview-page': isClientsOverview}">
                                        <h4>Message</h4>
                                        <sn-text-angular ng-if="!clientToken && isClientsOverview && mailDataClient.status === undefined && !customToken" 
                                                         sn-forbid-img-paste="true" '
                                                         sn-file-drop-handler="disableDragDrop" 
                                                         sn-files-model='tokenAttachmentsData'  
                                                         sn-model="sendMessageData.emailText" 
                                                         sn-name="send_message_text" 
                                                         sn-tools="[['bold', 'italics', 'underline'],['link','attachFilesFromComputer'],[ 'ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull' ], ['clientOverviewMailToken']]"
                                        ></sn-text-angular>
                                        <sn-text-angular ng-if="!clientToken && isClientsOverview && mailDataClient.status === undefined && customToken" 
                                                         sn-forbid-img-paste="true" '
                                                         sn-file-drop-handler="disableDragDrop" 
                                                         sn-files-model='tokenAttachmentsData'  
                                                         sn-model="sendMessageData.emailText" 
                                                         sn-name="send_message_text" 
                                                         sn-tools="[['bold', 'italics', 'underline'],['link','attachFilesFromComputer'],[ 'ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull' ], ['{{customToken}}']]"
                                        ></sn-text-angular>
                                        <sn-text-angular ng-if="clientToken && !isClientsOverview && mailDataClient.status === undefined" 
                                                         sn-forbid-img-paste="true" 
                                                         sn-file-drop-handler="disableDragDrop" 
                                                         sn-files-model='tokenAttachmentsData' 
                                                         sn-model="sendMessageData.emailText" 
                                                         sn-name="send_message_text" 
                                                         sn-tools="[['bold', 'italics', 'underline'],['link','attachFiles'],[ 'ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull' ], ['reminderTokens']]"
                                        ></sn-text-angular>
                                        <sn-text-angular ng-if="!clientToken && !isClientsOverview && mailDataClient.status === undefined" 
                                                         sn-forbid-img-paste="true" 
                                                         sn-file-drop-handler="disableDragDrop" 
                                                         sn-files-model='attachmentsData' 
                                                         sn-model="sendMessageData.emailText" 
                                                         sn-name="send_message_text" 
                                                         sn-tools="[['bold', 'italics', 'underline'],['link','attachFiles'],[ 'ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull' ], ['reminderTokens']]"
                                        ></sn-text-angular>
                                 
                                        <sn-text-angular ng-if="!clientToken && !isClientsOverview && mailDataClient.status === null" 
                                                         sn-forbid-img-paste="true" 
                                                         sn-file-drop-handler="disableDragDrop" 
                                                         sn-files-model='attachmentsData' 
                                                         sn-model="mailDataClient.emailText" 
                                                         sn-name="send_message_text" 
                                                         sn-tools="[['bold', 'italics', 'underline'],['link','attachFiles'],[ 'ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull' ], ['reminderTokens']]"
                                        ></sn-text-angular>
                                        <sn-text-angular ng-if="!clientToken && isClientsOverview && mailDataClient.status === null" 
                                                         sn-forbid-img-paste="true" 
                                                         sn-file-drop-handler="disableDragDrop" 
                                                         sn-files-model='tokenAttachmentsData' 
                                                         sn-model="mailDataClient.emailText" 
                                                         sn-name="send_message_text" 
                                                         sn-tools="[['bold', 'italics', 'underline'],['link','attachFilesFromComputer'],[ 'ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull' ], ['clientOverviewMailToken']]"
                                        ></sn-text-angular>
                                        <sn-text-angular ng-if="clientToken && !isClientsOverview && mailDataClient.status === null" 
                                                         sn-forbid-img-paste="true" 
                                                         sn-file-drop-handler="disableDragDrop" 
                                                         sn-model="mailDataClient.emailText" 
                                                         sn-name="send_message_text" 
                                                         sn-files-model='tokenAttachmentsData' 
                                                         sn-tools="[['bold', 'italics', 'underline'],['link','attachFiles'],[ 'ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull' ], ['reminderTokens']]"
                                        ></sn-text-angular>
                                     </div>
                                </div>
                                <div class="modal-footer modal-foot">
                                    <button type="submit" class="btn btn-success btn-lg" ng-disabled="disableBtnOnSend" spinning-wheel is-spinning-wheel-active="disableBtnOnSend">Send Email </button>
                                </div> 
                            </form>
                        </div>
                    </div>
                     <update-job-modal
						main-shoot-label-name="mainShootLabelName"
						extra-shoot-label-name="extraShootLabelName"
						business-number-label-name="businessNumberLabelName">
				</update-job-modal>
                </div>`;

				return templateHtml;
			},
			link(scope, element, attrs) {
				scope.isClientProfile = $location.path().includes('clients/');
				scope.isLeadPage = $location.path().includes('leads/');
				scope.isJobPage = $location.path().includes('jobs/');

				scope.clientEmails = [];
				scope.emailTemplates = [];
				scope.reminderrr = ['reminderTokens'];
				scope.sendMessageData = {};
				scope.uploadedAttachments = [];

				let isFirstShow = true;
				let clientsEmailTimer;
				const EMPTY_ATTACHMENTS_OBJECT = {
					attachments: [],
					filesSize: 0
				};

				let attachmentsObj = JSON.parse(
					JSON.stringify(EMPTY_ATTACHMENTS_OBJECT)
				);

				delete scope.sendMessage;

				scope.$watch(attrs.snCustomToken, token => {
					scope.customToken = token;
				});

				scope.$watch('mailData', newValue => {
					if (newValue) {
						setMailData(newValue);
					}
				});

				scope.$watch('showCcField', () => {
					scope.$evalAsync();
				});

				function clearAttachments() {
					scope.attachmentsData = JSON.parse(
						JSON.stringify(EMPTY_ATTACHMENTS_OBJECT)
					);
				}

				scope.attachmentsData = angular.copy(attachmentsObj);
				scope.tokenAttachmentsData = angular.copy(attachmentsObj);

				function prepareEmailTemplate(mailData) {
					const email = angular.copy(mailData.task.taskEmail);
					if (email.name) {
						email.name = stringModifierService.addSelectedText(email.name);
					}
					scope.emailTemplates.push(email);
					scope.selectedEmailTemplate = email;
				}

				scope.modalClose = function() {
					delete scope.uploadedAttachments;
					delete scope.attachmentsData;
					delete scope.emailTemplates;
					delete scope.selectedEmailTemplate;

					isFirstShow = true;
					if (scope.isLeadPage) {
						$rootScope.updateLeadView();
					} else if (scope.isJobPage) {
						$rootScope.updateJobView();
					}
				};

				scope.$watchCollection('attachmentsData', (newValue, oldValue) => {
					if (
						newValue &&
						newValue !== oldValue &&
						newValue.attachments.length &&
						newValue.attachments.length !== 0 &&
						scope.isUserEmail
					) {
						addUploadedAttachments(newValue);
					}
				});

				function addUploadedAttachments(attachmentsData) {
					const { attachments } = attachmentsData;
					scope.uploadedAttachments = [];
					angular.forEach(attachments, attachment => {
						if (!attachment.id) {
							scope.uploadedAttachments.push(attachment);
						} else if (attachment.hasOwnProperty('checked')) {
							const copiedAttachment = angular.copy(attachment);
							scope.uploadedAttachments.push(copiedAttachment);
						}
					});
				}

				const isUserEmail = email =>
					!email.hasOwnProperty('emailTemplateType') &&
					!email.hasOwnProperty('defaultEmailTemplate');

				// Call this fn for errors
				function setEmptyEmailData() {
					scope.selectedEmailTemplate = null;
					scope.sendMessageData.emailSubject = '';
					scope.sendMessageData.emailText = '';
					if (scope.mailData.mailSignature) {
						scope.sendMessageData.emailText += `<br><br>${
							scope.mailData.mailSignature
						}`;
					}
					scope.attachmentsData = angular.copy(attachmentsObj);
					scope.tokenAttachmentsData = angular.copy(attachmentsObj);
				}

				scope.changEmail = email => {
					if (email === null || email === undefined) {
						setEmptyEmailData();
					} else if (email && typeof email === 'object') {
						const isUserEmailChosen = isUserEmail(email);
						scope.isUserEmail = isUserEmail(email);

						if (isUserEmailChosen) {
							scope.selectedEmailTemplate = email;
							scope.sendMessageData.emailSubject = email.subject || '';
							scope.sendMessageData.emailText = email.text || '';

							const attachments = angular.copy(email.storedAttachments) || [];
							if (
								attachments.length ||
								(scope.uploadedAttachments && scope.uploadedAttachments.length)
							) {
								const storedAttachments = angular.copy(email.storedAttachments);
								const allAttachments =
									storedAttachments !== null
										? angular.copy(email.storedAttachments)
										: [];

								if (
									scope.uploadedAttachments &&
									scope.uploadedAttachments.length
								) {
									angular.forEach(scope.uploadedAttachments, attachment => {
										allAttachments.push(attachment);
									});
								}

								scope.attachmentsData = {
									attachments: allAttachments
								};
							} else {
								clearAttachments();
							}
						} else if (email.id) {
							templateRequestsService
								.getTemplates('full_template', email.id)
								.subscribe(emailTemplate =>
									successSetEmailTemplate(emailTemplate)
								);
						}
					} else {
						console.error('no chosen email');
					}
				};

				function successSetEmailTemplate(emailTemplate) {
					if (
						emailTemplate.storedAttachments &&
						emailTemplate.storedAttachments.length
					) {
						scope.attachmentsData = {
							attachments: fileUploadService.convertAttachmentsToShow(
								emailTemplate.storedAttachments
							)
						};
						scope.tokenAttachmentsData = angular.copy(scope.attachmentsData);
						scope.$evalAsync();
					} else {
						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);
					}
					scope.sendMessageData.emailSubject = emailTemplate.subject || '';
					scope.sendMessageData.emailText = emailTemplate.text || '';
					scope.$evalAsync();
				}

				scope.toggleViewCc = function(state) {
					scope.showCcField = state === undefined ? !scope.showCcField : state;
					if (state === false) {
						attachmentsObj = {
							attachments: [],
							filesSize: 0
						};

						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);
						if ($rootScope.updateLeadView) {
							$rootScope.updateLeadView();
						}
					}
				};

				scope.changEmailClient = () => {
					if (
						!scope.mailDataClient.choosenEmail ||
						!scope.mailDataClient.choosenEmail.id
					) {
						if (scope.mailDataClient.mailSignature) {
							scope.mailDataClient.emailText = '';
							scope.mailDataClient.emailText = `<br/><br/>${
								scope.mailDataClient.emailTextReply
							}<br/><br/>${scope.mailDataClient.mailSignature}`;
						}

						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);

						return false;
					}

					templateRequestsService
						.getTemplates('full_template', scope.mailDataClient.choosenEmail.id)
						.subscribe(emailTemplate => {
							if (emailTemplate) {
								if (
									emailTemplate.storedAttachments &&
									emailTemplate.storedAttachments.length
								) {
									scope.attachmentsData = {
										attachments: fileUploadService.convertAttachmentsToShow(
											emailTemplate.storedAttachments
										)
									};
									scope.tokenAttachmentsData = angular.copy(
										scope.attachmentsData
									);
								} else {
									scope.attachmentsData = angular.copy(attachmentsObj);
									scope.tokenAttachmentsData = angular.copy(attachmentsObj);
								}
								scope.mailDataClient.emailSubject = emailTemplate.subject || '';
								scope.mailDataClient.emailText = '';
								scope.mailDataClient.emailText = emailTemplate.text;
							}

							scope.$evalAsync();
						});
				};

				scope.toggleViewCc = function(state) {
					scope.showCcField = state === undefined ? !scope.showCcField : state;
					if (state === false) {
						attachmentsObj = {
							attachments: [],
							filesSize: 0
						};

						scope.attachmentsData = angular.copy(attachmentsObj);
						scope.tokenAttachmentsData = angular.copy(attachmentsObj);
					}
				};

				scope.setEmail = function(site, messageData, prop) {
					let stringEmail = angular.copy(site.name);
					stringEmail = stringEmail.substring(
						stringEmail.indexOf('(') + 1,
						stringEmail.length - 1
					);

					scope[messageData][prop] = stringEmail;
					if (prop === 'emailC') {
						scope.emailCcObj = Object.assign({ email: stringEmail }, site);
					}
				};

				function emailSearchRequest(search) {
					jobDataService
						.searchClient(search)
						.then(result => findClientSuccessCallback(result.data))
						.catch(messageService.showDefaultErrorMessage);
				}

				function findClientSuccessCallback(client) {
					if (client) {
						scope.clientEmails.length = 0;
						client.forEach(item => scope.clientEmails.push(item));
					}
				}

				function setMailData(newValue) {
					if (newValue === undefined) {
						return;
					}

					scope.emailTemplates = angular.copy(newValue.emails);

					scope.sendMessageData = {
						emailSubject: newValue.emailSubject || '',
						emailText: newValue.emailText || '',
						emailTo: newValue.email || '',
						emailCc: ''
					};
					if (newValue.mailSignature && newValue.task === undefined) {
						scope.sendMessageData.emailText += `<br><br>${
							newValue.mailSignature
						}`;
					}

					// if (isFirstShow) {
					//     isFirstShow = false;
					if (newValue.hasOwnProperty('task')) {
						const emailData = angular.copy(newValue.task.taskEmail);
						const isUserEmailChosen = isUserEmail(emailData);

						if (isUserEmailChosen) {
							scope.isUserEmail = true;
						}

						prepareEmailTemplate(newValue);
						const attachments =
							angular.copy(newValue.task.taskEmail.storedAttachments) || [];
						if (attachments.length) {
							scope.attachmentsData = {
								attachments: fileUploadService.convertAttachmentsToShow(
									attachments
								)
							};
						} else {
							clearAttachments();
						}
						scope.$evalAsync();
					} else {
						setEmptyEmailData();
					}
					// }
				}

				scope.changeInputField = (object, property) => {
					if (!scope[object][property]) {
						scope[object][property] = angular
							.element(`#${object}_${property}`)
							.val();
					}

					if (scope[object][property] && scope[object][property].length > 0) {
						if (clientsEmailTimer != null) {
							clearTimeout(clientsEmailTimer);
						}

						clientsEmailTimer = setTimeout(
							emailSearchRequest(scope[object][property]),
							500
						);
					} else {
						clearTimeout(clientsEmailTimer);
					}
				};

				scope.sendUserEmail = () => {
					if (scope.mailData.task !== undefined) {
						scope.mailData.task.taskEmail.emailTemplateId =
							scope.selectedEmailTemplate.id;
						scope.mailData.task.taskEmail.name =
							scope.selectedEmailTemplate.name;
						saveChangeTask(scope.mailData.task);
					} else {
						const maxSize = 10; // 10Mb
						if (
							scope.attachmentsData.filesSize > maxSize ||
							scope.tokenAttachmentsData.filesSize > maxSize
						) {
							messageService.showToaster('w_0', 'attachments');
							return false;
						}

						let _emailText = '';

						if (!scope.sendMessageData.emailText) {
							_emailText = jQuery('.in .textarea-quad textarea')[0].value;
						} else {
							_emailText = scope.sendMessageData.emailText;
						}

						scope.sendMessageData.emailText = $rootScope.addMaiStyling(
							_emailText
						);

						scope.disableBtnOnSend = true;
						let url = '';
						if ($route.current.params.leadId) {
							url = `/api/user/lead/${$route.current.params.leadId}/send/${
								scope.mailData.id
							}/`;
						} else if (
							scope.$parent.sendEmailLeadId &&
							scope.$parent.sendEmailLeadId !== null
						) {
							url = `/api/user/lead/${scope.$parent.sendEmailLeadId}/send/${
								scope.mailData.id
							}/`;
						} else {
							url = `/protected/rest/clients/send/${scope.mailData.id}/`;
							url += $route.current.params.jobId
								? $route.current.params.jobId
								: '';
						}

						scope.sendMessageData.templateId = '';
						if (scope.mailData.choosenEmail && scope.mailData.choosenEmail.id) {
							scope.sendMessageData.templateId = scope.mailData.choosenEmail.id;
						}

						const formData = new FormData();

						angular.forEach(scope.sendMessageData, (value, key) => {
							console.debug(`key: ${key}  | value: ${value}`);
							formData.append(key, value);
						});
						let storedFiles, uploadedFiles;
						const isTokenAttachmentsData =
							$rootScope.clientToken || scope.isClientsOverview;

						if (isTokenAttachmentsData) {
							storedFiles = scope.tokenAttachmentsData.attachments.filter(
								file => file.id
							);
							uploadedFiles = scope.tokenAttachmentsData.attachments.filter(
								file => !file.id
							);
						} else {
							storedFiles = scope.attachmentsData.attachments.filter(
								file => file.id
							);
							uploadedFiles = scope.attachmentsData.attachments.filter(
								file => !file.id
							);
						}

						angular.forEach(uploadedFiles, (value, key) => {
							formData.append(`attachments[${key}]`, value);
						});

						angular.forEach(storedFiles, (value, key) => {
							formData.append(`storedAttachments[${key}]`, value.id);
						});
						$http({
							method: 'POST',
							url,
							data: formData,
							transformRequest: angular.identity,
							headers: {
								'Content-Type': undefined
							}
						}).then(
							result => successSendEmail(),
							error => errorSendEmail(error)
						);
					}
				};

				scope.sendUserEmailReply = () => {
					const maxSize = 10; // 10Mb
					if (
						scope.attachmentsData.filesSize > maxSize ||
						scope.tokenAttachmentsData.filesSize > maxSize
					) {
						messageService.showToaster('w_0', 'attachments');
						return false;
					}

					let _emailText = '';

					if (!scope.sendMessageData.emailText) {
						_emailText = jQuery('.in .textarea-quad textarea')[0].value;
					} else {
						_emailText = scope.sendMessageData.emailText;
					}

					scope.sendMessageData.emailText = $rootScope.addMaiStyling(
						_emailText
					);

					scope.disableBtnOnSend = true;
					let url = '';
					if ($route.current.params.leadId) {
						url = `/api/user/lead/${$route.current.params.leadId}/send/${
							scope.mailDataClient.id
						}/`;
					} else {
						url = `/protected/rest/clients/send/${
							scope.mailDataClient.contactId
						}/`;
						url += $route.current.params.jobId
							? $route.current.params.jobId
							: '';
					}

					scope.mailDataClient.templateId = '';
					if (
						scope.mailDataClient.choosenEmail &&
						scope.mailDataClient.choosenEmail.id
					) {
						scope.mailDataClient.templateId =
							scope.mailDataClient.choosenEmail.id;
					}

					// sendMessageData

					const formData = new FormData();
					scope.mailDataClient.emailTo = scope.mailDataClient.from;
					if (scope.mailDataClient.emailCc === null) {
						delete scope.mailDataClient.emailCc;
					}
					angular.forEach(scope.mailDataClient, (value, key) => {
						console.debug(`key: ${key}  | value: ${value}`);
						formData.append(key, value);
					});
					let storedFiles, uploadedFiles;
					const isTokenAttachmentsData =
						$rootScope.clientToken || scope.isClientsOverview;

					if (isTokenAttachmentsData) {
						storedFiles = scope.tokenAttachmentsData.attachments.filter(
							file => file.id
						);
						uploadedFiles = scope.tokenAttachmentsData.attachments.filter(
							file => !file.id
						);
					} else {
						storedFiles = scope.attachmentsData.attachments.filter(
							file => file.id
						);
						uploadedFiles = scope.attachmentsData.attachments.filter(
							file => !file.id
						);
					}

					angular.forEach(uploadedFiles, (value, key) => {
						formData.append(`attachments[${key}]`, value);
					});

					angular.forEach(storedFiles, (value, key) => {
						formData.append(`storedAttachments[${key}]`, value.id);
					});
					$http({
						method: 'POST',
						url,
						data: formData,
						transformRequest: angular.identity,
						headers: {
							'Content-Type': undefined
						}
					}).then(() => successSendEmail(), error => errorSendEmail(error));
				};

				const handleTask = (task, taskTypes) => {
					if (task.dateItem) {
						task.dateItem = task.dateItem.toLowerCase();
					}

					if (task.due && !task.hasDue) {
						// for old workflows
						task.hasDue = true;
					}

					if (!task.action && task.taskEmail) {
						// for old workflows
						task.action = 'SEND_EMAIL';
					}

					if (task.calendarEventType === 'MAIN_SHOOT') {
						const {
							startDate,
							finishDate,
							startTime,
							finishTime,
							location
						} = $scope.job;
						task.location = location;
						task.startDate = startDate;
						task.endDate = finishDate;
						task.startTime = startTime;
						task.endTime = finishTime;
					} else if (task.calendarEvent) {
						const {
							startDate,
							endDate,
							startTime,
							endTime,
							location,
							clientId
						} = task.calendarEvent;
						task.location = location;
						task.startDate = startDate;
						task.endDate = endDate;
						task.startTime = startTime;
						task.endTime = endTime;
						task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

						if (
							task.startDate &&
							(task.startTime === null || task.finishTime === null)
						) {
							task.allday = true;
						}
					}

					task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
					task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
					task.taskDueDefault =
						task.defaultTask && task.dueDate ? task.dueDate : null;
				};

				const saveTaskWithAttachments = task => {
					prepareEmailAttachments(task.taskEmail).then(
						result => {
							task.taskEmail = result;
							saveChangeTask(task);
						},
						error => {
							scope.button_disabled = false;
						}
					);
				};

				const prepareEmailAttachments = taskEmail => {
					const deferred = $q.defer();
					taskEmail.attachmentsData = scope.attachmentsData;
					const isAttachments =
						taskEmail.attachmentsData &&
						taskEmail.attachmentsData.attachments.length;

					if (!isAttachments) {
						deferred.resolve(taskEmail);
						return deferred.promise;
					}

					const { attachments, filesSize } = taskEmail.attachmentsData;
					const maxSize = 10; // 10Mb

					if (filesSize > maxSize) {
						messageService.showToaster('w_0', 'attachments');
						deferred.reject('Attachments size exceeds the limit');
						return deferred.promise;
					}

					let uploadedAttachments, storedAttachments;

					if (attachments.length) {
						uploadedAttachments = attachments.filter(
							attachment => !attachment.id
						);
						scope.storedAttachmentsForMail = attachments.filter(
							attachment => attachment.id
						);
					}

					taskEmail.storedAttachments =
						storedAttachments && storedAttachments.length
							? storedAttachments
							: null;

					if (uploadedAttachments && uploadedAttachments.length) {
						fileUploadService
							.convertFileToSave(uploadedAttachments)
							.then(convertedFilesArr => {
								scope.base64AttachmentsForMail = convertedFilesArr;
								deferred.resolve(taskEmail);
							})
							.catch(error => console.log(error));
					} else {
						deferred.resolve(taskEmail);
					}

					delete taskEmail.attachmentsData;
					return deferred.promise;
				};

				function saveChangeTask(task) {
					scope.disableBtnOnSend = true;
					task.jobId = scope.mailData.jobId;
					if (
						scope.mailData.choosenEmail !== undefined &&
						scope.mailData.choosenEmail !== null
					) {
						task.taskEmail.emailTemplateId = scope.mailData.choosenEmail.id;
					}
					if (task.overdueDays !== null) {
						task.overdueDays = parseInt(task.overdueDays.match(/\d+/)[0], 10);
					}
					task.taskEmail.subject = scope.sendMessageData.emailSubject;
					task.taskEmail.text = scope.sendMessageData.emailText;
					task.taskEmail.storedAttachments = null;
					task.taskEmail.base64Attachments = null;
					scope.uploadedAttachments = null;
					if (
						scope.attachmentsData.attachments &&
						scope.attachmentsData.attachments.length !== 0
					) {
						task.taskEmail.storedAttachments = scope.attachmentsData.attachments.filter(
							attachment => attachment.id
						);
						scope.uploadedAttachments = scope.attachmentsData.attachments.filter(
							attachment => !attachment.id
						);
					}

					if (scope.uploadedAttachments && scope.uploadedAttachments.length) {
						fileUploadService
							.convertFileToSave(scope.uploadedAttachments)
							.then(convertedFilesArr => {
								task.taskEmail.base64Attachments = convertedFilesArr;
								workflowDataService
									.saveTask(task)
									.subscribe(
										data => changeTaskState(data.tasks[data.taskToAnimate]),
										error => errorSaveTask(error.data)
									);
							})
							.catch(error => console.log(error));
					} else {
						workflowDataService
							.saveTask(task)
							.subscribe(
								data => changeTaskState(data.tasks[data.taskToAnimate]),
								error => errorSaveTask(error.data)
							);
					}
				}

				function errorSaveTask(data) {
					scope.isSentSpinnningWheelActive = false;
					scope.disableBtnOnSend = false;
					workflowService.errorSaveTask(data);
				}

				function changeTaskState(task) {
					task.completed = true;
					newJobsDataService
						.changeTaskState(scope.mailData.jobId, task)
						.finally(() => {
							$rootScope.dnd.canMove = true;
							scope.disableBtnOnSend = false;
						})
						.subscribe(
							data => {
								toastr.clear();
								task = Object.assign(task, data);
								handleTask(task, scope.mailData.sortedTasksArr);
								isFirstShow = true;
								messageService.showToaster('s_4', 'clients');
								$('#sendContactEmailModal').modal('hide');
								messageService.showToaster('i_0', 'jobView');
								if (scope.isLeadPage) {
									$rootScope.updateLeadView();
								} else if (scope.isJobPage) {
									$rootScope.updateJobView();
								}
							},
							result => {
								toastr.clear();
								messageService.showDefaultErrorMessage(result);
							}
						);
				}

				function successSendEmail() {
					scope.disableBtnOnSend = false;
					scope.$evalAsync();
					isFirstShow = true;
					messageService.showToaster('s_4', 'clients');

					$('#sendContactEmailModal').modal('hide');

					if (scope.updateParent) {
						return scope.updateParent({ resetPagination: false });
					}

					if (scope.isLeadPage && $rootScope.updateLeadView) {
						if (scope.mailData.task !== undefined) {
							// changeTaskState(scope.mailData.task);
						} else {
							$rootScope.updateLeadView();
						}
					}

					if (scope.isJobPage && $rootScope.updateJobView) {
						if (scope.mailData.task !== undefined) {
							// changeTaskState(scope.mailData.task);
						} else {
							$rootScope.updateJobView();
						}
					}
					if (
						$rootScope.updateClientView &&
						$location.path().includes('/clients/')
					) {
						$rootScope.updateClientView();
					}
					scope.disableBtnOnSend = false;
					scope.showCcField = false;

					for (const prop in scope.sendMessageData) {
						scope.sendMessageData[prop] = '';
					}

					delete scope.attachmentsData;
					delete scope.uploadedAttachments;
					scope.tokenAttachmentsData.attachments.length = 0;
					scope.$evalAsync();
				}

				function errorSendEmail({ status, data }) {
					isFirstShow = false;
					scope.disableBtnOnSend = false;
					const { errorMessage, errorTitle } = data;

					const path = $location.path();
					const isClientsOverview = path.includes('clients');
					if (status >= 400 && status < 500 && errorMessage) {
						if (status === 423) {
							const limit = $rootScope.isUserTrial ? 50 : 150;
							return messageService.showToaster(
								'e_4',
								'generalValidation',
								limit
							);
						} else if (errorMessage.includes('Email address inactive')) {
							messageService.showToaster(
								'e_1',
								'generalValidation',
								scope.sendMessageData.emailTo
							);
						} else if (errorMessage.includes('Lead is archived')) {
							messageService.showToaster('e_5', 'lead');
						} else if (
							isClientsOverview &&
							errorMessage.includes('job-related variables')
						) {
							messageService.showToaster('e_7', 'clients');
						} else if (errorTitle) {
							messageService.showErrorFromBackend(errorTitle, errorMessage);
						} else {
							messageService.showToaster('e_2', 'general', errorMessage);
						}
					} else {
						messageService.showToaster('e_0', 'general');
					}
				}

				function getJobTypes() {
					return jobTypesDataService
						.getJobTypes()
						.map(data => successGetJobTypes(data));
				}

				function successGetJobTypes(data) {
					scope.newJob.jobTypes = angular.copy(data);
				}

				function getWorkflowNames() {
					return workflowDataService
						.getWorkflowNames()
						.map(data => successGetWorkflowNames(data));
				}

				function successGetWorkflowNames(data) {
					if (!data) {
						return false;
					}
					scope.newJob.workflowNames = angular.copy(data);
				}

				function showNewJobModal(event) {
					const selectModal = '#sendContactEmailModal',
						nextModal = '#newJob';
					scope.$broadcast('showModalJob', scope.newJob);
					utilsService.showNextModal(selectModal, nextModal, event);
				}

				scope.addNewJob = event => {
					scope.newJob = {};
					scope.clients = [];
					const primaryClientSearchText = jobDataService.fillClientSearchText(
						scope.mailData
					);
					scope.clients[0] = primaryClientSearchText;
					scope.newJob.primaryContact = scope.clients[0];
					scope.workflowNames = [];

					Rx.Observable.zip(getJobTypes(), getWorkflowNames())
						// .takeUntil($scope.unsubscribe)
						.subscribe(() => showNewJobModal(event));
				};

				scope.disableDragDrop = () => true;

				$('#sendContactEmailModal')
					.on('show.bs.modal', () => {
						scope.$broadcast('addedFileEvent');
						$('#sendContactEmailModal')
							.find('input')
							.prop('autocomplete', 'off');

						if (
							typeof scope.mailDataClient === 'undefined' ||
							scope.mailDataClient === null ||
							!scope.mailDataClient.hasOwnProperty('emailText')
						) {
							scope.mailDataClient = {};
						} else if (
							scope.mailDataClient.emailText === '' ||
							scope.mailDataClient.emailText === '<p></p>'
						) {
							scope.mailDataClient.emailText = `<br><br>${
								scope.mailDataClient.emailTextReply
							}<br>`;

							if (scope.mailDataClient.subject.indexOf('RE:') !== -1) {
								scope.mailDataClient.subject = `RE: ${
									scope.mailDataClient.subject
								}`;
							}
						}
					})
					.on('shown.bs.modal', () => {
						const input = $('input');
						const select = $('select');

						validationService.isModalClosePrevented(input);
						validationService.isModalClosePrevented(select);
					});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/modalSendMail.js